<div class="select-challenge-container">
  <div class="select-challenge-header">
    <app-heading [spacingBottom]="40">
      <button
        class="challenge-back-button"
        (click)="goBack()"
        data-test-id="challenge-select-back-button"
      >
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.53699 12.2636C7.88848 12.615 7.88851 13.1849 7.53705 13.5364C7.1856 13.8879 6.61575 13.8879 6.26426 13.5364L0.263637 7.53643C-0.087879 7.18495 -0.087879 6.61505 0.263637 6.26357L6.26426 0.263571C6.61575 -0.0878828 7.1856 -0.0878532 7.53705 0.263637C7.88851 0.615127 7.88848 1.18498 7.53699 1.53643L2.17286 6.9L7.53699 12.2636Z"
            fill="#2F3133"
          />
        </svg>
      </button>
      {{ 'challenges.selectChallenge' | translate }}
    </app-heading>
  </div>
  <div class="filters-section">
    <div class="search-container">
      <app-input
        type="search"
        size="small"
        [icon]="InputIcon.SEARCH"
        placeholder="{{ 'common.search' | translate }}"
        data-test-id="challenge-select-search"
        [inputValue]="searchInput"
        (typeahead)="onSearch()"
      ></app-input>
    </div>
    <app-accordion
      title="Duration"
      accordionStyle="floating"
      buttonWidth="180px"
      contentWidth="283px"
      data-test-id="challenge-select-accordion"
    >
      <app-range-select
        [start]="minLength"
        [end]="maxLength"
        [showLabels]="true"
        noStartLabel="challenges.noMin"
        noEndLabel="challenges.noMax"
        labelFormat="challenges.weeks"
        labelFormatSingular="challenges.week"
        [min]="0"
        [max]="21"
        (rangeInput)="onLengthInput($event)"
        (rangeChanged)="onLengthChange($event)"
        [disabled]="isLoading()"
        data-test-id="challenge-select-range-select"
      >
      </app-range-select>
    </app-accordion>
  </div>
  @if (isLoading()) {
  <app-spinner data-test-id="challenge-select-spinner"></app-spinner>
  } @else {
  <app-card-data-grid
    [data]="cards()"
    (cardSelected)="onChallengeSelected($event)"
    data-test-id="challenge-select-card-data-grid"
  ></app-card-data-grid>
  @if (!cards()?.length) {
  <p class="no-results" data-test-id="challenge-select-no-results">
    {{ 'common.noSearchResults' | translate }}
  </p>
  } }
</div>
